import React from 'react';
import PropTypes from 'prop-types';
import classes from './FooterParagraph.module.scss';

const FooterParagraph = ({ children }) => (
  <p className={classes.footerParagraph}>{children}</p>
);

FooterParagraph.propTypes = {
  children: PropTypes.string.isRequired,
};

export default FooterParagraph;
